import React from 'react';
import { withRouter } from 'react-router-dom';
import Helmet from 'react-helmet';
import styles from './styles.css';

function NotFoundPage(props) {
  return (
    <div>
      <Helmet title="Not Found" />
      <div className="container">
        <div className="row">
          <div className="col-md-10 col-md-push-1 col-lg-8 col-lg-push-2">
            <div className={styles.main}>
              <h1>Page not found!</h1>
              <div className={styles.graphic}></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}


NotFoundPage.propTypes = {
};

NotFoundPage.contextTypes = {
};

export default withRouter(NotFoundPage);
